<template>
	<div
		v-for="(item, index) in sectorMenuList"
		:key="index"
		class="container cursor-pointer"
		@click="onClickCard(item.tab)"
	>
		<component :is="item.icon" :data="item" />
		<span class="sector_title"> {{ item.tab }}</span>
	</div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

import { sectorMenuList } from '@/constants/menu';

// -----variable-----
const router = useRouter();

// -----function-----
const onClickCard = (item: string) => {
	router.push({ path: `/etf/list/섹터`, query: { tab: item } });
};
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	padding: 1.6rem;
	height: 14rem;
	.img_box {
		width: 5rem;
		height: 5rem;
	}
	.sector_title {
		font-size: var(--font-s-mid);
		font-weight: var(--font-w-semi-bold);
		line-height: normal;
	}
}
</style>
